const SEARCH_CARDS = 'SEARCH_CARDS'
const SEARCH_TAXES = 'SEARCH_TAXES'
const CALCULATOR_POINTS_CASH = 'CALCULATOR_POINTS_CASH'
const REDEMPTION_CARD = 'REDEMPTION_CARD'
const AUTHORIZE_TOKEN = 'AUTHORIZE_TOKEN'

export default (state = {}, action) => {
  switch (action.type) {
    case `${SEARCH_CARDS}_SUCCESS`:
      return {
        ...state,
        participantCard: action.payload.data
      }
    case `${SEARCH_CARDS}_FAIL`:
      return {
        ...state,
        participantCard: { success: false }
      }
    case `${SEARCH_TAXES}_SUCCESS`:
      return {
        ...state,
        cardTaxes: {
          partnerTax: action.payload.data,
          success: true
        }
      }
    case `${SEARCH_TAXES}_FAIL`:
      return {
        ...state,
        cardTaxes: { success: false }
      }
    case `${CALCULATOR_POINTS_CASH}_SUCCESS`:
      return {
        ...state,
        calculatorPoints: {
          pointsCash: action.payload.data,
          success: true
        }
      }
    case `${CALCULATOR_POINTS_CASH}_FAIL`:
      return {
        ...state,
        calculatorPoints: {
          success: false
        },
        alertError: {
          show: true,
          isError: true,
          title: 'Erro ao calcular o valor a ser creditado',
          message: 'Foi encontrado um erro ao calcular o valor a ser creditado no cartão like+'
        }
      }
    case REDEMPTION_CARD:
      return {
        ...state,
        loading: true
      }
    case `${REDEMPTION_CARD}_SUCCESS`:
      return {
        ...state,
        order: {
          ...action.payload.data,
          success: true
        },
        loading: false
      }
    case `${REDEMPTION_CARD}_FAIL`:
      var requestError = action.error.request
      let secondFactorAuthentication = {}
      let alertError = {
        show: true,
        isError: true,
        title: 'Oops !!!',
        message: 'Houve algum erro ao realizar a carga no seu cartão. Por favor tente novamente.'
      }
      if ((requestError.status === 401 || requestError.status === 406) && requestError.response) {
        if (requestError.response.message === '2FA Required' && requestError.response.description === 'AuthenticationRequired') {
          secondFactorAuthentication = {
            enable: true,
            AuthenticationConfirmed: true,
            confirmedOrderId: requestError.response.orderId,
            phone: requestError.response.phone
          }
          alertError = {
            ...alertError,
            title: 'Oops !!!',
            message: 'Para finalizar o pagamento, é necessário inserir o token de verificação.'
          }
        } else if (requestError.response.status === 'OnBoardingRequired') {
          secondFactorAuthentication = {
            enable: true,
            AuthenticationConfirmed: false
          }
        }
      }
      if (requestError.response && requestError.response.declinedMessage) {
        alertError = {
          ...alertError,
          title: requestError.response.declinedMessage.title,
          message: requestError.response.declinedMessage.description
        }
      }
      return {
        ...state,
        order: {
          ...action.error.response,
          success: false
        },
        secondFactorAuthentication,
        loading: false,
        alertError
      }
    case `${AUTHORIZE_TOKEN}_FAIL`:
      let tokenFinishedError = {
        show: true,
        isError: true,
        title: 'Oops !!!',
        message: 'Houve algum erro ao realizar a carga no seu cartão. Por favor tente novamente.'
      }
      if (action.error.response.data.status === 'TokenFinished') {
        tokenFinishedError = {
          ...tokenFinishedError,
          title: 'Não foi possível concluir o seu pagamento',
          message: 'Tentativas de verificação de token excedidas!'
        }
      }
      return {
        ...state,
        secondFactorAuthentication: null,
        authorized: false,
        alertError: tokenFinishedError
      }
    case `${AUTHORIZE_TOKEN}_SUCCESS`:
      if (action.payload.data.status === 'RequiresTokenValidation') {
        return { ...state }
      } else {
        return {
          ...state,
          secondFactorAuthentication: null,
          order: {
            ...action.payload.data,
            success: true
          },
          loading: false,
          authorized: true
        }
      }
    default:
      return state
  }
}

export const searchCards = cpf => ({
  type: SEARCH_CARDS,
  payload: {
    client: 'mileageApi',
    request: {
      method: 'get',
      url: `mileage-api/v1/card/SearchCards?cpf=${cpf}`
    }
  }
})

export const searchTaxes = () => ({
  type: SEARCH_TAXES,
  payload: {
    client: 'mileageApi',
    request: {
      method: 'get',
      url: `mileage-api/v1/tax/calculated-values`
    }
  }
})

export const calculatorPointsToCash = points => ({
  type: CALCULATOR_POINTS_CASH,
  payload: {
    client: 'mileageApi',
    request: {
      method: 'get',
      url: `mileage-api/v1/calculators/pointsToMiles/${parseFloat(points).toFixed()}`
    }
  }
})

export const redemptionCard = order => ({
  type: REDEMPTION_CARD,
  payload: {
    client: 'mileageApi',
    request: {
      method: 'post',
      url: `mileage-api/v1/orders/redemption`,
      data: order
    }
  }
})



// WEBPACK FOOTER //
// ./src/features/LikePlus/ducks.js